import { User, Shield, Key, Copy, Check } from 'lucide-react';
import { useState } from 'react';
import { useWalletStore } from '../../stores/useWalletStore';
import { useAccountStore } from '../../stores/useAccountStore';
import { useProjectStore } from '../../stores/useProjectStore';
import s from './Pages.module.css';

export function AccountPage() {
  const wallet = useWalletStore();
  const deployments = useAccountStore(a => a.deployments);
  const earnings = useAccountStore(a => a.earnings);
  const projects = useProjectStore(p => p.projects);
  const [copied, setCopied] = useState(false);

  const addr = wallet.activeAccount?.address ?? '—';
  const totalEarnings = earnings.reduce((sum, e) => sum + parseFloat(e.amount || '0'), 0);

  const copyAddress = () => {
    if (wallet.activeAccount?.address) {
      navigator.clipboard.writeText(wallet.activeAccount.address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className={s.page}>
      <div className={s.pageHeader}>
        <h1 className={s.pageTitle}>Account</h1>
        <p className={s.pageSubtitle}>Your wallet identity &amp; platform summary.</p>
      </div>

      {/* Identity Card */}
      <div style={{ background: 'var(--color-bg-secondary)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-lg)', padding: '28px 32px', marginBottom: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--color-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <User size={28} color="#fff" />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, color: 'var(--color-text-tertiary)', marginBottom: 4 }}>Wallet Address</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13, color: 'var(--color-text-primary)', wordBreak: 'break-all' }}>{addr}</span>
              {wallet.activeAccount && (
                <button className={s.btnGhost} onClick={copyAddress} style={{ padding: 4, minWidth: 0 }}>
                  {copied ? <Check size={14} /> : <Copy size={14} />}
                </button>
              )}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <span className={`${s.badge} ${s.badgeSuccess}`}><Shield size={12} /> ML-DSA-65 (Dilithium3)</span>
          <span className={`${s.badge} ${s.badgeInfo}`}><Key size={12} /> Post-Quantum Secure</span>
        </div>
      </div>

      {/* Stats */}
      <div className={s.statsRow}>
        <div className={s.statCard}>
          <div className={s.statLabel}>Projects</div>
          <div className={s.statValue}>{projects.length}</div>
        </div>
        <div className={s.statCard}>
          <div className={s.statLabel}>Deployments</div>
          <div className={s.statValue}>{deployments.length}</div>
        </div>
        <div className={s.statCard}>
          <div className={s.statLabel}>Total Earnings</div>
          <div className={s.statValue}>{totalEarnings.toLocaleString()} NAT</div>
        </div>
        <div className={s.statCard}>
          <div className={s.statLabel}>Security</div>
          <div className={s.statValue}>PQ</div>
        </div>
      </div>

      {/* Security Section */}
      <div className={s.sectionHeader}>
        <h2 className={s.sectionTitle}>Security</h2>
      </div>
      <div style={{ background: 'var(--color-bg-secondary)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-lg)', padding: 24 }}>
        <table className={s.table}>
          <tbody>
            <tr><td style={{ fontWeight: 500 }}>Signature Scheme</td><td>ML-DSA-65 (CRYSTALS-Dilithium3)</td></tr>
            <tr><td style={{ fontWeight: 500 }}>Key Type</td><td>Post-Quantum Lattice-Based</td></tr>
            <tr><td style={{ fontWeight: 500 }}>NIST Standard</td><td>FIPS 204</td></tr>
            <tr><td style={{ fontWeight: 500 }}>Public Key Size</td><td>1,952 bytes</td></tr>
            <tr><td style={{ fontWeight: 500 }}>Signature Size</td><td>3,293 bytes</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
